module.exports = __webpack_public_path__ + "static/img/coreTechnology_1.8914bc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/coreTechnology_1.jpg
// module id = yxo7
// module chunks = 0